import { render, staticRenderFns } from "./CaliperDetailsComponent.vue?vue&type=template&id=fe41d8fc&scoped=true"
import script from "./CaliperDetailsComponent.js?vue&type=script&lang=js&external"
export * from "./CaliperDetailsComponent.js?vue&type=script&lang=js&external"
import style0 from "./CaliperDetailsComponent.vue?vue&type=style&index=0&id=fe41d8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe41d8fc",
  null
  
)

export default component.exports